import type { Labels, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_LABELS_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllMarketingLabelsQuery {
  allMarketingLabels: {
    edges: Labels[]
    pageInfo: PageInfo
  }
}
export interface AllMarketingLabelsQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_MARKETING_LABELS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allMarketingLabels(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_LABELS_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllMarketingLabels = (
  variables: AllMarketingLabelsQueryVariables
) =>
  useQuery<AllMarketingLabelsQuery, AllMarketingLabelsQueryVariables>(
    GQL_QUERY_ALL_MARKETING_LABELS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
